import { getAttribution } from '../../utils/attribution'

export const SERVICES = [
  'Stair Remodeling',
  'Floating Stairs',
  'Glass Railings',
  'Custom Stairs',
  'Shower Remodel',
  'Finish Carpentry',
  'Other',
]

export const CONTACT_METHODS = ['Phone', 'Text', 'Email']

export const MIN_DESCRIPTION_LENGTH = 20

/**
 * Shared logic for the lead / callback forms.
 * Components provide their own template; validation, payload building and the
 * submit request live here so both forms stay in sync.
 */
export default {
  data: () => ({
    loading: false,
    ordered: false,
    validated: false,
    server_errors: [],
    services: SERVICES,
    contactMethods: CONTACT_METHODS,
    minDescription: MIN_DESCRIPTION_LENGTH,
    form: {
      user_name: '',
      user_phone: '',
      user_email: '',
      user_location: '',
      service: '',
      preferred_contact_method: 'Phone',
      user_text: '',
    },
    files: [],
  }),
  computed: {
    errors () {
      const errors = []
      if (!this.form.user_name.trim()) {
        errors.push('Please enter your full name.')
      }
      if (this.form.user_phone.length !== 10) {
        errors.push('Please enter a valid phone number.')
      }
      if (!/^\S+@\S+\.\S+$/.test(this.form.user_email.trim())) {
        errors.push('Please enter a valid email address.')
      }
      if (!this.form.user_location.trim()) {
        errors.push('Please enter your ZIP code or city.')
      }
      if (!this.form.service) {
        errors.push('Please select the service you are interested in.')
      }
      if (this.form.user_text.trim().length < MIN_DESCRIPTION_LENGTH) {
        errors.push(`Please add a short project description (at least ${MIN_DESCRIPTION_LENGTH} characters).`)
      }
      return errors
    },
  },
  methods: {
    handleFileUpload () {
      this.files = Array.from((this.$refs.file && this.$refs.file.files) || [])
    },
    invalid (field) {
      return this.validated && this.errors.some(e => e.toLowerCase().includes(field))
    },
    submitLead () {
      this.validated = true
      if (this.errors.length) {
        return
      }
      this.server_errors = []
      this.loading = true

      const formData = new FormData()
      Object.keys(this.form).forEach(key => formData.append(key, this.form[key]))
      this.files.forEach(file => formData.append('attach_file[]', file))

      const attribution = getAttribution()
      Object.keys(attribution).forEach(key => formData.append(key, attribution[key]))

      axios.post('/api/callback/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }).then(({ status }) => {
        if (status === 200) {
          this.ordered = true
          // Non-PII params only (Google policy).
          window.trackLead({
            service: this.form.service,
            contact_method: this.form.preferred_contact_method,
            has_photos: this.files.length > 0,
            utm_source: attribution.utm_source || undefined,
            utm_campaign: attribution.utm_campaign || undefined,
          })
        }
      }).catch(error => {
        if (error.response && error.response.data && error.response.data.errors) {
          Object.values(error.response.data.errors).forEach(item => {
            item.forEach(e => this.server_errors.push(e))
          })
        } else {
          this.server_errors.push('Sending error. Please reload the page and try again.')
        }
      }).finally(() => {
        this.loading = false
      })
    },
  },
}
